// How the status column of every eRegulation listing is drawn: the framed label, text
// and frame in the status's text colour over its background - see `statusVariant` in
// TableCellContent. Spread into the column's cell config next to its colour keys.
export const STATUS_PILL_CELL_CONFIG = Object.freeze({
  statusVariant: 'pill',
  style: {
    textAlign: 'center'
  },
  wrapperStyle: {
    width: '100%',
    minWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  statusStyle: {
    display: 'flex',
    width: '100%',
    minWidth: '100%',
    boxSizing: 'border-box',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    height: '24px',
    paddingRight: '12px',
    paddingLeft: '12px',
    whiteSpace: 'nowrap'
  }
})
